export const darkMode = (instance) => {
    // const theme = instance.element.closest("midwest-theme") as any;
    const theme = closestElement("midwest-theme", instance.element);
    if (theme) {
        instance.dark = theme.store.get("dark");
        theme.store.onChange("dark", (dark) => { instance.dark = dark; });
    }
};
const closestElement = (selector, base) => {
    function __closestFrom(el) {
        if (!el || el === document || el === window) {
            return null;
        }
        const found = el.closest(selector);
        return found ? found : __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
};
//# sourceMappingURL=darkMode.js.map